export default __webpack_public_path__ + "static/media/auto-renewal-promotion.296680af.png";